import { Adapter as e } from "../../../../adapter.js";
import { LoyaltyProgrammeValidityScheduleModel as o } from "./loyaltyProgrammeValiditySchedule.model.js";
class l extends e {
  adapt(r) {
    return new o({
      days: r.days ?? [],
      startHour: r.start_hour,
      endHour: r.end_hour
    });
  }
  serialize(r) {
  }
}
export {
  l as LoyaltyProgrammeValidityScheduleAdapter
};
//# sourceMappingURL=loyaltyProgrammeValiditySchedule.adapter.js.map
